import Axios from "axios";

let cfg = null as ({ [key: string]: any } & { idp?: { clientId: string } }) | null;

export class Configuration {
  public static async get<T>(key?: string): Promise<{ [key: string]: any } & { idp?: { clientId: string } } & T> {
    cfg = cfg || (await Axios.get(`${process.env.BASE_URL}configuration.json`));

    return (key ? cfg!.data[key] : cfg!.data) as { [key: string]: any } & { idp?: { clientId: string } } & T;
  }
}
